module.exports = __webpack_public_path__ + "3bd64884f60c72fecb03e36a53ff3b5a.svg";